import { Topic } from '../../types/Topic';
import { FiltersObject } from '../../utils/filterUtils';

type DetailedFilters = {
    topics: Topic[];
    isLoading: boolean;
    filters: FiltersObject;
    setFilters: (filter: FiltersObject) => void;
};

const DetailedFilters = ({}: DetailedFilters) => {
    return <></>;
};

export { DetailedFilters };
